ACC.paginationsort = {

  bindAll: function() {
    this.bindPaginaSort();
  },
  bindPaginaSort: function() {
    ACC.paginationsort.bindSortForm($('#sort_form1'));
    ACC.paginationsort.bindSortForm($('#sort_form2'));
  },

  bindSortForm: function(sortForm) {
    sortForm.change(function() {
      this.submit();
    });
  }
};

$(document).ready(function() {
  ACC.paginationsort.bindAll();
});

